import type { ConfigurationContextValue } from "./ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import darkModeLogo from "./logos/logo_gula_dark.png";
import lightModeLogo from "./logos/logo_gula_light.png";

export const defaultDarkModeLogo = darkModeLogo;
export const defaultLightModeLogo = lightModeLogo;

export const defaultCurrency = "EUR";

// The Gula logo already carries the brand name, so the header only adds "CRM".
export const defaultTitle = "CRM";

export const defaultCompanySectors = [
  { value: "private", label: "Particular" },
  { value: "hospitality", label: "Hostelería" },
  { value: "office", label: "Oficina" },
  { value: "retail", label: "Comercio" },
  { value: "other", label: "Otro" },
];

export const defaultDealStages = [
  { value: "new", label: "Nuevo" },
  { value: "calling", label: "Llamando" },
  { value: "no-answer", label: "No contesta" },
  { value: "interested", label: "Interesado" },
  { value: "payment-link-sent", label: "Enlace de pago enviado" },
  { value: "won", label: "Ganado" },
  { value: "lost", label: "Perdido" },
];

export const defaultDealPipelineStatuses = ["won"];

export const defaultDealCategories = [
  { value: "blua-auxiliary-tap", label: "BLUA grifo auxiliar (499 €)" },
  { value: "blua-three-way-tap", label: "BLUA grifo 3 vías (699 €)" },
  { value: "plan-essential", label: "Plan Esencial" },
  { value: "plan-premium", label: "Plan Premium" },
  { value: "other", label: "Otro" },
];

export const defaultNoteStatuses = [
  { value: "cold", label: "Frío", color: "#7dbde8" },
  { value: "warm", label: "Templado", color: "#e8cb7d" },
  { value: "hot", label: "Caliente", color: "#e88b7d" },
  { value: "in-contract", label: "Cliente", color: "#a4e87d" },
];

export const defaultTaskTypes = [
  { value: "none", label: "Sin tipo" },
  { value: "call", label: "Llamada" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "email", label: "Email" },
  { value: "follow-up", label: "Seguimiento" },
  { value: "ship", label: "Envío" },
  { value: "installation", label: "Instalación" },
  { value: "maintenance", label: "Mantenimiento" },
  { value: "repair", label: "Avería" },
];

export const defaultConfiguration: ConfigurationContextValue = {
  companySectors: defaultCompanySectors,
  currency: defaultCurrency,
  dealCategories: defaultDealCategories,
  dealPipelineStatuses: defaultDealPipelineStatuses,
  dealStages: defaultDealStages,
  noteStatuses: defaultNoteStatuses,
  taskTypes: defaultTaskTypes,
  title: defaultTitle,
  darkModeLogo: defaultDarkModeLogo,
  lightModeLogo: defaultLightModeLogo,
};
